export default {"src":"/_next/static/media/instagram.3fd4d9df.svg","height":44,"width":44};